import { ScaleLinear, scaleLinear, ScaleTime, scaleTime } from 'd3-scale'
import { State } from '../../types'
export default function (
    state: State,
    dimension: number,
    type = 'time'
): ScaleLinear<number, number> | ScaleTime<number, number> {
    if (state._span || state.span || state.customSpan) {
        const span = state._span || state.span
        const normalized = state.start?.info?.span?.normalized || ''
        const isRealtime = normalized.indexOf('now') >= 0 && normalized.indexOf('shifted') < 0
        const end = isRealtime ? span.end + (span.end - span.begin) * 0.1 : span.end
        const scale = type === 'time' ? scaleTime() : scaleLinear()

        return scale
            .domain([span.begin !== undefined ? span.begin : span.start, end])
            .range([0, dimension])
            .clamp(true)
    } else {
        return scaleLinear()
    }
}
